import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

function AdminSettings() {
  const [settings, setSettings] = useState({});
  const token = localStorage.getItem('token');

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = () => {
    apiService.getSettings()
      .then(response => setSettings(response.data.settings))
      .catch(error => console.error('Error loading settings:', error));
  };

  const handleChange = (key, value) => {
    setSettings({
      ...settings,
      [key]: value
    });
  };

  const handleSave = (e) => {
    e.preventDefault();
    apiService.updateSettings(settings, token)
      .then(() => {
        alert('Settings saved successfully!');
      })
      .catch(error => console.error('Error saving settings:', error));
  };

  return (
    <div>
      <h2>Settings</h2>
      
      <div className="admin-card">
        <form onSubmit={handleSave} className="admin-form">
          <h3>Site Information</h3>
          
          <div className="form-group">
            <label>Site Name</label>
            <input
              type="text"
              value={settings.site_name || ''}
              onChange={(e) => handleChange('site_name', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label>Site Email</label>
            <input
              type="email"
              value={settings.site_email || ''}
              onChange={(e) => handleChange('site_email', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              value={settings.site_phone || ''}
              onChange={(e) => handleChange('site_phone', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label>Address</label>
            <textarea
              value={settings.site_address || ''}
              onChange={(e) => handleChange('site_address', e.target.value)}
              rows="3"
            />
          </div>
          
          <h3 style={{marginTop: '40px'}}>Email Settings (SMTP)</h3>
          
          <div className="form-group">
            <label>SMTP Host</label>
            <input
              type="text"
              value={settings.smtp_host || ''}
              onChange={(e) => handleChange('smtp_host', e.target.value)}
              placeholder="smtp.gmail.com"
            />
          </div>
          
          <div className="form-group">
            <label>SMTP Port</label>
            <input
              type="text"
              value={settings.smtp_port || ''}
              onChange={(e) => handleChange('smtp_port', e.target.value)}
              placeholder="587"
            />
          </div>
          
          <div className="form-group">
            <label>SMTP Username</label>
            <input
              type="text"
              value={settings.smtp_username || ''}
              onChange={(e) => handleChange('smtp_username', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label>SMTP Password</label>
            <input
              type="password"
              value={settings.smtp_password || ''}
              onChange={(e) => handleChange('smtp_password', e.target.value)}
            />
          </div>
          
          <div className="form-group">
            <label>SMTP Encryption</label>
            <select
              value={settings.smtp_encryption || 'tls'}
              onChange={(e) => handleChange('smtp_encryption', e.target.value)}
            >
              <option value="tls">TLS</option>
              <option value="ssl">SSL</option>
            </select>
          </div>
          
          <button type="submit" className="btn-save">Save Settings</button>
        </form>
      </div>
    </div>
  );
}

export default AdminSettings;
